export default {
  common: {
    search: '查 詢 ',
    reset: '重 置',
    deleteTip: '確定刪除嗎？',
    title: '提示',
    confirm: '確定',
    cancel: '取消'
  },
  select: {
    loading: '加載中',
    noMatch: '無匹配數據',
    noData: '無數據',
    placeholder: '請選擇'
  },
  input: {
    placeholder: '請輸入'
  },
  tableFilter: {
    expand: '展開',
    packUp: '收起'
  },
  table: {
    toolbar: {
      reset: '重置',
      refreshTable: '刷新列表',
      exportExcel: '導出Excel',
      combinationSort: '組合排序',
      columnsSetup: '列設置',
      leftFixed: '左固定',
      notFixed: '不固定',
      rightFixed: '右固定',
      default: '默認',
      sortUp: '升序',
      sortDown: '降序',
      fixedSort: '固定 / 排序',
      sortDrag: '排序 / 拖動',
      dragDropSort: '拖拽排序',
      confirm: '確定',
      restore: '還原',
      colorPickerMessage: '請至少選擇一條數據'
    }
  },
  apexNavigator: {
    title: 'Apex 產品地圖己上線',
    content: 'Apex產品地圖全新上線!一圖掌握全局，探索從此開始！歡迎體驗',
    view: '查看',
    cancel: '退出'
  }
}
